import { inject, ref, onMounted } from 'vue'

export function useFormFieldPrefill(uuid, initialValue) {
    const fieldValue = ref(initialValue.value || '')
    const prefillValues = inject('formPrefillValues', ref(null))

    const preFill = () => {
        if (prefillValues.value && prefillValues.value[uuid]?.value !== undefined) {
            fieldValue.value = prefillValues.value[uuid].value
        }
    }

    onMounted(() => {
        preFill()
    })

    return {
        fieldValue
    }
}
